/// <amd-module name="SuiteCommerce.GridOrder.Item.Controller"/>
define("SuiteCommerce.GridOrder.Item.Controller", ["require", "exports", "underscore", "SuiteCommerce.GridOrder.Common.DependencyProvider", "SuiteCommerce.GridOrder.Configuration", "SuiteCommerce.GridOrder.Item.Model"], function (require, exports, _, DependencyProvider_1, GridOrder_Configuration_1, Item_Model_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var GridOrderItemController = /** @class */ (function () {
        function GridOrderItemController(options) {
            this.item = options.item;
            if (this.itemIsValidMatrix()) {
                this.setRowOption();
                this.setColumnOption();
            }
        }
        GridOrderItemController.prototype.getColumnOption = function () {
            return this.columnOption;
        };
        GridOrderItemController.prototype.getRowOption = function () {
            return this.rowOption;
        };
        GridOrderItemController.prototype.getHeadersFromItem = function () {
            var headers;
            var columnOption = this.columnOption;
            var rowOption = this.rowOption

            var optionValues ;
            if(columnOption){
                if(columnOption.label === "Color"){
                    optionValues = rowOption
                }else{
                    optionValues = columnOption
                }
            }

            if (optionValues) {
                headers = _.filter(optionValues.values, function (option) {
                    if (option.internalid) {
                        option.sourcefrom = optionValues.sourcefrom;
                        option.matrixOptionInternalid = optionValues.internalid;
                    }
                    return !!option.internalid && option.isAvailable;
                });
            }
            return headers || [];
        };
        GridOrderItemController.prototype.getRowsFromItem = function () {
            if (this.columnOption && !this.rowOption) {
                return this.getMatrixChildItemsForSingleDimension();
            }
            return this.getMatrixChildItemsGroupedByRowOption();
        };
        GridOrderItemController.prototype.itemIsValidMatrix = function () {
            var itemOptionsDetails = this.item.itemOptionsDetails;
            var gridOrderBehavior = this.item.gridOrderBehavior;
            var gridOrderSiteWideConfig = GridOrder_Configuration_1.GridOrderConfiguration.isActivatedForAllMatrixItems;
            if (gridOrderBehavior === Item_Model_1.GridOrderBehavior.DefaultSiteBehavior && !gridOrderSiteWideConfig) {
                // Disabled at domain level
                return false;
            }
            if (gridOrderBehavior === Item_Model_1.GridOrderBehavior.DesactivateForThisItem) {
                // Disable at level item
                return false;
            }
            if (itemOptionsDetails && !itemOptionsDetails.fields) {
                // Item doesn't have any option
                return false;
            }
            if (this.item.matrixOptions.length === 0 || this.item.matrixOptions.length > 2) {
                // Matrix's dimensions are invalid
                return false;
            }
            if (this.item.mandatoryNonMatrixOptions.length > 0) {
                // Item has mandatory options
                return false;
            }
            return !DependencyProvider_1.ProfileModel.getInstance().hidePrices();
        };
        GridOrderItemController.prototype.setRowOption = function () {
            var _this = this;
            var options = this.item.matrixOptions;
            var matrixDimensionsArrangement = this.getMatrixDimensionsArrangement();
            var rowOption;

            if (matrixDimensionsArrangement) {
                rowOption = _.find(options, function (option) {
                    return option.sourcefrom === matrixDimensionsArrangement.rowMatrixDimension;
                });
                this.rowOption = rowOption;
            }
            else {
                this.rowOption = options[0];
            }

            if (this.rowOption) {
                _.each(this.rowOption.values, function (value) {

                    value.customItemFieldId = _this.rowOption.sourcefrom;
                });
            }
        };
        GridOrderItemController.prototype.setColumnOption = function () {
            var _this = this;
            var options = this.item.matrixOptions;
            var matrixDimensionsArrangement = this.getMatrixDimensionsArrangement();
            var columnOption;
            if (matrixDimensionsArrangement) {
                columnOption = _.find(options, function (option) {
                    return option.sourcefrom === matrixDimensionsArrangement.columnMatrixDimension;
                });
                this.columnOption = columnOption;
            }
            else {
                this.columnOption = options[1];
            }
            if (this.columnOption) {
                _.each(this.columnOption.values, function (value) {
                    value.customItemFieldId = _this.columnOption.sourcefrom;
                });
            }
        };
        GridOrderItemController.prototype.getMatrixDimensionsArrangement = function () {
            var _this = this;
            var arrangementList = GridOrder_Configuration_1.GridOrderConfiguration.matrixDimensionArrangements;
            return _.find(arrangementList, function (dimensionArrangement) {
                var columnDimension = dimensionArrangement.columnMatrixDimension;
                var rowDimension = dimensionArrangement.rowMatrixDimension;
                var matchColumnDimension;
                var matchRowDimension;
                if (_this.item.matrixOptions.length === 1) {
                    matchColumnDimension = columnDimension === _this.item.matrixOptions[0].sourcefrom && !rowDimension;
                    matchRowDimension = rowDimension === _this.item.matrixOptions[0].sourcefrom && !columnDimension;
                    return matchColumnDimension || matchRowDimension;
                }
                matchColumnDimension = columnDimension === _this.item.matrixOptions[0].sourcefrom
                    || columnDimension === _this.item.matrixOptions[1].sourcefrom;
                matchRowDimension = rowDimension === _this.item.matrixOptions[0].sourcefrom
                    || rowDimension === _this.item.matrixOptions[1].sourcefrom;
                return matchColumnDimension && matchRowDimension;
            });
        };
        GridOrderItemController.prototype.getMatrixChildItemsForSingleDimension = function () {
            var _this = this;
            var matrixChildItemsGrouped = {
                matrixChildItems: [],
            };
            if (!this.rowOption) {
                this.rowOption = this.columnOption;
            } 
            // Get all children grouped by matrix options
            _.each(this.rowOption.values, function (value) {
                if (value.internalid) {
                    // Get child items for current row option
                    var matrixChildItemsForMatrixOption = _.find(_this.item.matrixChildItemsDetail, function (matrixChildItem) {
                        return matrixChildItem[_this.rowOption.sourcefrom] === value.label;
                    });
                    if (matrixChildItemsForMatrixOption) {
                        matrixChildItemsGrouped.matrixChildItems.push(matrixChildItemsForMatrixOption);
                    }
                    else {
                        matrixChildItemsGrouped.matrixChildItems.push({});
                    }
                }
            });
            // Add parent item attributes to child item
            _.each(matrixChildItemsGrouped.matrixChildItems, function (matrixChildItem) {
                matrixChildItem.outofstockmessage = _this.item.outStockMessage;
                matrixChildItem.custitem_ns_sc_grid_order_show_stock = _this.item.isShowStockEnabled;
                matrixChildItem.custitem_ns_sc_grid_order_stock_notif = _this.item.isShowStockNotificationsEnabled;
                matrixChildItem.parentInternalId = _this.item.internalId;
            });
            return [matrixChildItemsGrouped];
        };
        GridOrderItemController.prototype.getMatrixChildItemsGroupedByRowOption = function () {
            var _this = this;
            var matrixChildItems = this.item.matrixChildItemsDetail;
            var matrixChildItemsGrouped = {};
            var rowOption = this.rowOption;
            var columnOption = this.columnOption;

            if(rowOption.label != "Color" && rowOption.label != "Fin Colour"){
                var optionValues;
                if(columnOption){
                    optionValues = columnOption
                }else{
                    optionValues = rowOption
                }

                _.each(optionValues.values, function (matrixOptionValue) {

                        if (matrixOptionValue.internalid) {
                            // Get child items for current row option
                            var matrixChildItemsForMatrixOption = _.filter(matrixChildItems, function (matrixChildItem) {                
                                return matrixChildItem[optionValues.sourcefrom] === matrixOptionValue.label;
                            });

                            if (matrixChildItemsForMatrixOption) {
                                if (columnOption) {
                                    // Sort item by column option
                                    matrixChildItemsForMatrixOption = _this.sortMatrixChildItemsByColumnOptionSorting(matrixChildItemsForMatrixOption);
                                }
                                    if (!matrixChildItemsGrouped[matrixOptionValue.label]) {
                                        matrixChildItemsGrouped[matrixOptionValue.label] = {
                                            matrixChildItems: matrixChildItemsForMatrixOption,
                                            matrixOptionDetail: matrixOptionValue,
                                        };
                                }
                                else {
                                    matrixChildItemsGrouped[matrixOptionValue.label].matrixChildItems.push(matrixChildItemsForMatrixOption);
                                }
                                // Add parent item attributes to child item
                                _.each(matrixChildItemsGrouped[matrixOptionValue.label].matrixChildItems, function (matrixChildItem) {
                                    matrixChildItem.outofstockmessage = _this.item.outStockMessage;
                                    matrixChildItem.custitem_ns_sc_grid_order_show_stock = _this.item.isShowStockEnabled;
                                    matrixChildItem.custitem_ns_sc_grid_order_stock_notif = _this.item.isShowStockNotificationsEnabled;
                                    matrixChildItem.parentInternalId = _this.item.internalId;
                                });

                            }
                        }
                    });  
                
            }else{
                _.each(rowOption.values, function (matrixOptionValue) {
                    if (matrixOptionValue.internalid) {
                        // Get child items for current row option
                        var matrixChildItemsForMatrixOption = _.filter(matrixChildItems, function (matrixChildItem) {
                            return matrixChildItem[rowOption.sourcefrom] === matrixOptionValue.label;
                        });

                        if (matrixChildItemsForMatrixOption) {
                            if (_this.columnOption) {
                                // Sort item by column option
                                matrixChildItemsForMatrixOption = _this.sortMatrixChildItemsByColumnOptionSorting(matrixChildItemsForMatrixOption);
                            }
                            if (!matrixChildItemsGrouped[matrixOptionValue.label]) {
                                matrixChildItemsGrouped[matrixOptionValue.label] = {
                                    matrixChildItems: matrixChildItemsForMatrixOption,
                                    matrixOptionDetail: matrixOptionValue,
                                };
                            }
                            else {
                                matrixChildItemsGrouped[matrixOptionValue.label].matrixChildItems.push(matrixChildItemsForMatrixOption);
                            }
                            // Add parent item attributes to child item
                            _.each(matrixChildItemsGrouped[matrixOptionValue.label].matrixChildItems, function (matrixChildItem) {
                                matrixChildItem.outofstockmessage = _this.item.outStockMessage;
                                matrixChildItem.custitem_ns_sc_grid_order_show_stock = _this.item.isShowStockEnabled;
                                matrixChildItem.custitem_ns_sc_grid_order_stock_notif = _this.item.isShowStockNotificationsEnabled;
                                matrixChildItem.parentInternalId = _this.item.internalId;
                            });
                        }
                    }
                });
            }
            // Get all children grouped by matrix options
            
            return _.values(matrixChildItemsGrouped);
        };
        GridOrderItemController.prototype.sortMatrixChildItemsByColumnOptionSorting = function (matrixChildItems) {
           
            var matrixOption;
            var optionValues;

            if(this.columnOption){
                if(this.columnOption.label ===  "Color"){
                    matrixOption = this.rowOption.sourcefrom;
                    optionValues  = this.rowOption.values
                }else{
                    matrixOption = this.columnOption.sourcefrom;
                    optionValues  = this.columnOption.values
            }
            }
            
            var matrixChildItemsSorted = [];
            _.each(optionValues, function (column) {
                if (column.internalid) {
                    var matrixChild = _.find(matrixChildItems, function (matrixChildItem) {
                        return column.label === matrixChildItem[matrixOption];
                    });

                    if (matrixChild) {
                        matrixChildItemsSorted.push(matrixChild);
                    }
                    else {
                        // Doesn't exist a child for the current Row-Column options.
                        // So we an empty object is stored in matrixChildItemsSorted to indicate that
                        // combination doesn't exit
                        // @ts-ignore
                        matrixChildItemsSorted.push({});
                    }
                }
            });
            return matrixChildItemsSorted;
        };
        return GridOrderItemController;
    }());
    exports.GridOrderItemController = GridOrderItemController;
});
